import { html } from 'lit-element';
import { TmnConfirmationToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';

class ResetPasswordBtn extends TmnConfirmationToolBase {
    constructor() {
        super();
        this.disabled = false;
        this.buttonColor = 'error';
        this.useIconButton = true;
    }

    static get properties() {
        return {
            disabled: {
                type: Boolean,
            },
            displayName: {
                type: String,
            },
            eventData: {
                type: Object,
            },
            useIconButton: {
                type: Boolean,
            },
        };
    }

    getButtonLabel() {
        return 'Reset Password';
    }

    getToolTitle() {
        return 'Reset Password';
    }

    getConfirmationLabel() {
        const { displayName } = this;
        return `Are you sure want to reset password for ${displayName}?`;
    }
    renderButton() {
        return this.useIconButton ? this.renderIconButton() : this.renderStandardButton();
    }
    renderStandardButton() {
        return html`
            <tmn-button
                title="Reset Password"
                @click=${this._toggleDialog}
                .eventData=${this.eventData}>
                <tmn-icon iconvariant="outlined" slot="startIcon" icon="lock_reset"></tmn-icon>
                Reset Password</tmn-button
            >
        `;
    }

    renderIconButton() {
        return html`<tmn-icon-button
            title="Reset Password"
            @click=${this._toggleDialog}
            .eventData=${this.eventData}
            variant="text">
            <tmn-icon iconvariant="outlined" icon="lock_reset"></tmn-icon
        ></tmn-icon-button>`;
    }

    _handleConfirm(e) {
        // could pass in actions as an alternative
        const { eventData } = this;
        this._toggleDialog();
        const event = new CustomEvent('tmn-reset-password-confirmed', {
            detail: {
                ...eventData,
            },
        });
        this.dispatchEvent(event);
    }
}

window.customElements.define('reset-password-btn', ResetPasswordBtn);
